export enum CompassApiStatusEnum{
	ok = 'OK',
	zero = 'ZERO_RESULTS'
}